<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<el-input
						v-model="key"
						placeholder="请输入自提点名称"
						size="small"
						@keyup.enter.native="search">
						<!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>省：</span>
					<el-select v-model="ruleForm.province" size='small' class='select-box region' @change='provinceChange($event, "ruleForm")' placeholder="请选择省份">
						<el-option
							v-for="(item,index) in provinceList"
							:key="index"
							:label="item.name"
							:value="JSON.stringify(item)"
							ref="province">
						</el-option>
					</el-select>
					<span>市：</span>
					<el-select v-model="ruleForm.city"  size='small' class='select-box' @change='cityChange($event, "ruleForm")' placeholder="请选择城市">
						<el-option
							v-for="(item,index) in cityList"
							:key="index"
							:label="item.name"
							:value="JSON.stringify(item)">
						</el-option>
					</el-select>
					<span>区：</span>
					<el-select v-model="ruleForm.district"  size='small' class='select-box' @change='districtChange($event, "ruleForm")' placeholder="请选择区域">
						<el-option
							v-for="(item,index) in areaList"
							:key="index"
							:label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container" style="position:relative">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" icon="el-icon-plus"  v-if="AuthorityList['01_0008_0001_00']" style="height:32px" @click="goEdit">新增</el-button>
			<el-button size="small" type="primary" plain style="height:32px"  v-if="AuthorityList['01_0008_0003_00']" @click="muitlSet">批量删除</el-button>
		</div>
	</div>
</template>

<script>
import { cityData } from '@/js/location/city.js'
import { areaData } from '@/js/location/areaData.js'
import { provinceData } from '@/js/location/province.js'
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		tableData: {
			type: Array
		},
		customList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean
	},
	data () {
		return {
			collapse: false,
			methodValue: 2,
			percentValue: '',
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			bc: [],
			sc: [],
			disabledflag: -1,
			shop: [],
			customer: [],
			category: [],
			level: [],
			normal: [],
			special: [],
			key: '',
			shopList: [],
			levelList: [],
			kehuList: [],
			normalList: [],
			specialList: [],
			templateType: -1,
			templateName: '',
			templateList: [],
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			ruleForm: {
				province: '',
				city: '',
				district: ''
			}
		}
	},
	created () {
		if (this.$route.query.shopid) {
			this.shop = [this.$route.query.shopid]
		}
	},
	mounted () {
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
	},
	methods: {
		goEdit () {
			this.$router.push(`/main/selfDeliveryEdit`)
		},
		provinceChange () {
			this.areaList = []
			this.ruleForm.district = ''
			this.cityList = []
			this.ruleForm.city = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (JSON.parse(this.ruleForm.province).id === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
		},
		cityChange () {
			let province = JSON.parse(this.ruleForm.province).name
			let city = JSON.parse(this.ruleForm.city).id
			this.areaList = []
			this.ruleForm.district = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].name) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.areaList = areaData[i].child[j].child
						}
					}
				}
			}
		},
		muitlSet () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选数据')
				return false
			}
			this.$confirm('是否要删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					ids: this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/deleteShopSelfPickInfo`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('modifySuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			// let province = JSON.parse(this.ruleForm.province).id
			let province = this.ruleForm.province ? JSON.parse(this.ruleForm.province).id : ''
			let city = this.ruleForm.city ? JSON.parse(this.ruleForm.city).id : ''
			this.$emit('handleSearch', { key: this.key, province: province, city: city, district: this.ruleForm.district })
		},
		clear () {
			this.ruleForm.province = ''
			this.ruleForm.city = ''
			this.ruleForm.district = ''
			this.cityList = []
			this.areaList = []
			this.key = ''
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	text-align: left
	flex-wrap: wrap
	.input-title {
		display: inline-block;
		text-indent: 1em
	}
	.select-box {
		margin-right: 5px
	}
	&.filters-box-row2 {
		padding-top: 0;
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 200px
		}
		.filter-input {
			width: 135px
		}
	}
}
.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		max-height: 350px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				i {
					margin-right: 5px
				}
				img {
					margin-right: 5px
				}
				.head-right {
					margin-left: auto;
					span {
						margin-right: 5px
					}
				}
			}
		}
	}
	.btn-box {
		text-align: right;
		margin-top: 15px;
	}
</style>
<style lang="stylus">
</style>
